"use strict";

var _toConsumableArray = require("/home/runner/work/partner-forms-ui/partner-forms-ui/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var validate_1 = __importDefault(require("../validate"));
function validateGroup() {
  var validationGroup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var invalidFields = validationGroup.map(function (item, index) {
    return {
      fieldIndex: index,
      validationResult: (0, validate_1.default).apply(void 0, _toConsumableArray(item))
    };
  }).filter(function (item) {
    return !item.validationResult.isValid;
  });
  var hasInvalidFields = invalidFields.length > 0;
  return {
    allFieldsValid: !hasInvalidFields,
    invalidFields: invalidFields
  };
}
exports.default = validateGroup;